module.exports = __webpack_public_path__ + "static/img/pdk-02.fed952ee.jpg";